import React from 'react';
import { colors } from '../../constants/theme';
import { phaseLabel } from '../../constants/phases';

const MatchCard = ({ match, isOrganizer, onUpdateScore, onFinishMatch }) => {
  // Garantir que temos os dados corretos
  const player1Goals = match.player1?.goals ?? match.goals?.player1 ?? 0;
  const player2Goals = match.player2?.goals ?? match.goals?.player2 ?? 0;

  console.log('🎮 MatchCard dados:', {
    matchId: match.id,
    player1: match.player1?.name,
    player1Goals,
    player2: match.player2?.name,
    player2Goals,
    status: match.status
  });

  if (isOrganizer) {
    return (
      <div className="bg-white p-6 rounded-lg shadow">
        <div className="flex justify-between items-center mb-4">
          <span className="text-sm font-medium px-2 py-1 rounded text-white" 
                style={{ backgroundColor: colors.primary }}>
            {phaseLabel(match.phase).toUpperCase() || 'PARTIDA'}
          </span>
          <div className="text-xs text-gray-500">
            <div>ID: {match.id}</div>
            <div>Status: {match.status}</div>
          </div>
        </div>
        
        <div className="space-y-4">
          <div className="flex items-center justify-between p-3 border rounded">
            <span className="font-medium">{match.player1?.name}</span>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => {
                  console.log(`➖ Decrementar: Match ${match.id}, Player ${match.player1.id}`);
                  onUpdateScore(match.id, match.player1.id, 'remove');
                }}
                className="bg-red-500 text-white w-8 h-8 rounded-full hover:bg-red-600 disabled:opacity-50"
                disabled={player1Goals <= 0}
              >
                -
              </button>
              <span className="text-2xl font-bold w-8 text-center">
                {player1Goals}
              </span>
              <button
                onClick={() => {
                  console.log(`➕ Incrementar: Match ${match.id}, Player ${match.player1.id}`);
                  onUpdateScore(match.id, match.player1.id, 'add');
                }}
                className="bg-green-500 text-white w-8 h-8 rounded-full hover:bg-green-600"
              >
                +
              </button>
            </div>
          </div>
          
          <div className="text-center text-gray-500 font-bold">VS</div>
          
          <div className="flex items-center justify-between p-3 border rounded">
            <span className="font-medium">{match.player2?.name}</span>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => {
                  console.log(`➖ Decrementar: Match ${match.id}, Player ${match.player2.id}`);
                  onUpdateScore(match.id, match.player2.id, 'remove');
                }}
                className="bg-red-500 text-white w-8 h-8 rounded-full hover:bg-red-600 disabled:opacity-50"
                disabled={player2Goals <= 0}
              >
                -
              </button>
              <span className="text-2xl font-bold w-8 text-center">
                {player2Goals}
              </span>
              <button
                onClick={() => {
                  console.log(`➕ Incrementar: Match ${match.id}, Player ${match.player2.id}`);
                  onUpdateScore(match.id, match.player2.id, 'add');
                }}
                className="bg-green-500 text-white w-8 h-8 rounded-full hover:bg-green-600"
              >
                +
              </button>
            </div>
          </div>
        </div>
        
        <button
          onClick={() => {
            if (window.confirm(`Finalizar partida?\n${match.player1?.name} ${player1Goals} x ${player2Goals} ${match.player2?.name}`)) {
              onFinishMatch(match.id);
            }
          }}
          className="w-full mt-4 py-2 px-4 text-white rounded-lg font-medium hover:opacity-90"
          style={{ backgroundColor: colors.primary }}
        >
          Finalizar Partida
        </button>
      </div>
    );
  }

  // Versão para espectadores
  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <div className="text-center mb-4">
        <span className="text-lg font-bold px-4 py-2 rounded text-white" 
              style={{ backgroundColor: colors.primary }}>
          {phaseLabel(match.phase).toUpperCase() || 'PARTIDA EM ANDAMENTO'}
        </span>
      </div>
      <div className="flex items-center justify-between text-center">
        <div className="flex-1">
          <div className="text-lg font-semibold">{match.player1?.name}</div>
          <div className="text-3xl font-bold" style={{ color: colors.primary }}>
            {player1Goals}
          </div>
        </div>
        <div className="mx-8">
          <div className="text-2xl font-bold text-gray-500">VS</div>
        </div>
        <div className="flex-1">
          <div className="text-lg font-semibold">{match.player2?.name}</div>
          <div className="text-3xl font-bold" style={{ color: colors.primary }}>
            {player2Goals}
          </div>
        </div>
      </div>
      
      {/* Mostrar tempo da partida */}
      {match.startTime && (
        <div className="mt-4 text-center text-sm text-gray-500">
          Iniciada em: {new Date(match.startTime).toLocaleTimeString()}
        </div>
      )}
    </div>
  );
};

export default MatchCard;